import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const importAttendeesSlice = getBulkActionSlice(
    'addAttendeesResult',
);

export const selectImportAttendeesUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.addAttendeesResult.uuid;

export const selectImportAttendeesShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.addAttendeesResult.shown;

export const selectImportAttendeesTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.addAttendeesResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = importAttendeesSlice.actions;
